// frontend/src/pages/PayrollDrafts/useMutations.ts
// Async mutations for the pay-runs list.
// Hook owns the API call and loading flag; parent owns side effects (closing modals, refetching).

import { useState } from "react";
import apiFetch from "../../utils/apiFetch";
import { authHeaders } from "./helpers";

interface DeletePayRunResult {
  success: boolean;
  error?: string;
}

export function usePayRunMutations() {
  const [deleting, setDeleting] = useState<boolean>(false);

  /**
   * Delete a pay run (draft or finalized). Returns a result object;
   * the parent decides what to do on failure (alert, keep the modal open, etc.).
   */
  async function deletePayRun(runId: string): Promise<DeletePayRunResult> {
    setDeleting(true);
    try {
      const res = await apiFetch("/api/v1/payroll/runs/" + runId, {
        method: "DELETE",
        headers: authHeaders(),
      });
      if (!res.ok && res.status !== 204) {
        const txt = await res.text();
        return { success: false, error: txt || "Delete failed" };
      }
      return { success: true };
    } catch (e) {
      return { success: false, error: (e as Error).message };
    } finally {
      setDeleting(false);
    }
  }

  return {
    deletePayRun,
    deleting,
  };
}